module.exports = __webpack_public_path__ + "static/media/bd-mms_bd-institute-diversion-rp-en-report.bdda0661.pdf";